import { createContext, useContext, type ReactNode } from 'react';
import { useGateway, type UseGatewayResult } from './useGateway';

export const MAIN_SESSION = 'agent:main:main';
const AlexContext = createContext<UseGatewayResult | null>(null);

/** One connection and active conversation for every signed-in SCC surface. */
export function AlexGatewayProvider({ children }: { children: ReactNode }) {
    const gateway = useGateway(MAIN_SESSION);
    return <AlexContext.Provider value={gateway}>{children}</AlexContext.Provider>;
}

export function useAlexGateway(): UseGatewayResult {
    const gateway = useContext(AlexContext);
    if (!gateway) throw new Error('AlexGatewayProvider is required');
    return gateway;
}
